import i18n from '../../i18n/i18n';
import {EmailConfirmationPrice} from '../../projects/emailConfirmation-0424/prices';

/**
 * I63 — display-only relabel of the two plan cards to trial framing:
 * "Try free / 7-Day Trial" and "$0.99 / 30-Day Trial".
 *
 * This is the single manipulation under test. It isolates the plan-card relabel that shipped
 * unintentionally to B10's `experimental_control` arm only (see
 * `graduation-signaling/arms.ts` → `relabelCards`), where it moved plan mix toward
 * `30d099_annual_70` by +29.4% relative with total trial starts unchanged. In B10 the relabel
 * was bundled with that arm's header tense and CTA copy, so it was never isolated.
 *
 * Returns a copy — never mutates the product. The result is for the plan cards ONLY: it must
 * not reach Stripe, because `code`, `price` and `sheetLabel` have to stay canonical. Callers
 * resolve the Stripe-facing product separately from `getEmailConfirmationProducts()`.
 */
export function withTrialFraming(product: EmailConfirmationPrice): EmailConfirmationPrice {
  return {
    ...product,
    // Gate the title swap on the intro price, not on `daysFree === 7`, so a student variant's
    // strike-through price `title` survives untouched if one is added later.
    title: product.price === 0 ? i18n.t('common.try_free') : product.title,
    subtitle: i18n.t('checkout_screen.days_trial', {daysFree: product.daysFree}),
  };
}
